import React, { Component } from 'react';
import '../css/Universum.css';
import UniversumLogin from './UniversumLogin';


export class Universum extends Component {
    constructor(props) {
        super(props);
        var bandera = false;
        this.state = {
            LoggedIn: bandera,
            Err: ""
        };
        this.reportarLogin = this.reportarLogin.bind(this);
    }

    reportarLogin() {
        this.setState({ LoggedIn: true });
    }


    componentDidMount() {

        //var a = 0;

        //this.props.mostrarMenu(false);

        var xhr = new XMLHttpRequest();
        var principal = this;
        //var sobre = { Carrera: this.state.Clave };

        xhr.open("GET", "ead/Universum/IsLogged", true);

        xhr.setRequestHeader("Content-Type", "application/json");

        xhr.onload = function () {
            if (xhr.status === 200) {
                if (xhr.responseText == "true") {
                    principal.setState({ LoggedIn: true })
                } else {
                    //alert(xhr.responseText);

                }

            } else {

                alert(xhr.responseText);

            }


        };

        xhr.send();

    }

    render() {
        return (
            <div>
                {
                    this.state.LoggedIn ?
                        <div> Logeado</div>
                        :
                        <UniversumLogin reportarLogin={this.reportarLogin} />
                            
                }
            </div> 


        )
    }
}
export default Universum;


// WEBPACK FOOTER //
// ./src/components/Universum.js